// A FORMA DAS PLANILHAS DE TESTE — colunas das tres abas de entrada e da aba
// de saida.
//
// Mesma razao de `posicional-colunas.ts`: o catalogo precisa das colunas para
// montar o documento tecnico e o adaptador precisa do catalogo para saber a
// versao. Com a declaracao aqui, os dois leem o mesmo array e nao ha ciclo.
//
// COLUNA DE PLANILHA E' NOME, NAO POSICAO. Por isso ha duas listas por aba: a
// declarada (o que o documento descreve, na ordem em que a gente escreveria) e
// a OBRIGATORIA (o conjunto que `acharCabecalho` procura para dizer "esta aba
// e' a de descontos"). Coluna a mais e' relatada e ignorada; coluna a menos e'
// recusa nomeada. Ordem nao importa em nenhuma das duas — e' o valor
// `nome-de-coluna-ordem-livre` da matriz, e o exemplo o exercita mandando a aba
// de descontos com as colunas fora da ordem declarada.
import { SITUACAO_CARGA } from "../../retorno.js";
export const TESTE_PLANILHA_VERSAO = "1.0";
/**
 * Ate quantas linhas de titulo o cabecalho pode estar depois do topo.
 *
 * O relatorio real traz duas ("Relatório de servidores…" e a competencia), mas
 * o numero muda entre versoes do relatorio e o CONJUNTO DE COLUNAS nao — por
 * isso `acharCabecalho` procura a primeira linha que tem as colunas, dentro
 * deste limite, em vez de pular um numero fixo.
 */
export const TITULOS_ANTES_DO_CABECALHO = 5;
/**
 * Numero com PONTO decimal e virgula de milhar (`12,345.67`).
 *
 * A celula de planilha chega sem locale (`3517.31`), mas a celula que era
 * TEXTO na origem chega como a pessoa digitou — e nesse relatorio ela vem
 * agrupada. Declarar os dois no mesmo formato faz as duas formas lerem igual;
 * adivinhar faria "1.234" ser mil e duzentos num arquivo e um e pouco no
 * outro.
 */
export const NUMERO_PONTO = { decimal: "ponto", milhar: "virgula" };
/** A forma de TEXTO equivalente as abas — so' o teste de equivalencia a usa. */
export const DELIMITACAO_EQUIVALENTE = { separador: ";", aspas: "opcionais" };
// ---------------------------------------------------------------- entrada
export const ABA_SERVIDORES = "Servidores";
export const ABA_DESCONTOS = "Descontos";
export const ABA_HOLERITE = "Holerite";
/** O que a aba de servidores PRECISA ter para ser reconhecida como tal. */
export const OBRIGATORIAS_SERVIDORES = [
    "Matricula",
    "CPF",
    "Nome",
    "Situacao",
    "Salario",
    "MesReferencia",
];
/** `Contrato` e' o que distingue o extrato de descontos do holerite. */
export const OBRIGATORIAS_DESCONTOS = ["Matricula", "Verba", "Valor", "Contrato"];
/** `Tipo` (provento ou desconto) e' o que distingue o holerite do extrato. */
export const OBRIGATORIAS_HOLERITE = ["Matricula", "Verba", "Valor", "Tipo"];
export const COLUNAS_TESTE_SERVIDORES = [
    {
        nome: "Matricula",
        coluna: 1,
        kind: "alfa",
        obrigatorio: true,
        descricao: "Matrícula do servidor. Sufixo de vínculo (`-A`) é removido e o fato entra no relatório.",
    },
    {
        nome: "CPF",
        coluna: 2,
        kind: "cpf",
        obrigatorio: true,
        descricao: "Aceita com máscara e sem os zeros à esquerda (célula numérica); a Atlas completa e confere o dígito.",
    },
    { nome: "Nome", coluna: 3, kind: "alfa", obrigatorio: true, descricao: "Nome do servidor." },
    {
        nome: "Situacao",
        coluna: 4,
        kind: "codigo",
        obrigatorio: true,
        codigos: SITUACAO_CARGA,
        descricao: "Situação funcional, já no código do padrão Atlas.",
    },
    { nome: "Vinculo", coluna: 5, kind: "alfa", descricao: "Vínculo funcional." },
    { nome: "Cargo", coluna: 6, kind: "alfa", descricao: "Cargo." },
    {
        nome: "Admissao",
        coluna: 7,
        kind: "num",
        descricao: "Data de admissão como **serial de planilha** (dias desde 30/12/1899).",
    },
    {
        nome: "Salario",
        coluna: 8,
        kind: "dinheiro",
        obrigatorio: true,
        descricao: "Salário base do cálculo de margem. **Ponto decimal**; vírgula de milhar é aceita.",
    },
    { nome: "Banco", coluna: 9, kind: "alfa", descricao: "Código do banco de crédito do salário." },
    { nome: "Agencia", coluna: 10, kind: "alfa", descricao: "Agência." },
    { nome: "Conta", coluna: 11, kind: "alfa", descricao: "Conta." },
    {
        nome: "MesReferencia",
        coluna: 12,
        kind: "dataBr",
        obrigatorio: true,
        descricao: "Primeiro dia da competência, em **AAAA-MM-DD**. É daqui que sai a competência do pacote.",
    },
];
export const COLUNAS_TESTE_DESCONTOS = [
    {
        nome: "Matricula",
        coluna: 1,
        kind: "alfa",
        obrigatorio: true,
        descricao: "Casa com a coluna `Matricula` da aba de servidores, sufixo incluído.",
    },
    {
        nome: "Verba",
        coluna: 2,
        kind: "alfa",
        obrigatorio: true,
        descricao: "Código da rubrica de desconto na folha.",
    },
    { nome: "Descricao", coluna: 3, kind: "alfa", descricao: "Descrição da verba como sai no holerite." },
    {
        nome: "Contrato",
        coluna: 4,
        kind: "alfa",
        obrigatorio: true,
        descricao: "**Número do contrato (ADF)** devolvido pelo ente — é o que permite casar sem ambiguidade.",
    },
    {
        nome: "Valor",
        coluna: 5,
        kind: "dinheiro",
        obrigatorio: true,
        descricao: "Valor efetivamente descontado. **Ponto decimal**; vírgula de milhar é aceita.",
    },
];
export const COLUNAS_TESTE_HOLERITE = [
    {
        nome: "Matricula",
        coluna: 1,
        kind: "alfa",
        obrigatorio: true,
        descricao: "Casa com a coluna `Matricula` da aba de servidores.",
    },
    { nome: "Verba", coluna: 2, kind: "alfa", obrigatorio: true, descricao: "Código da rubrica na folha." },
    { nome: "Descricao", coluna: 3, kind: "alfa", descricao: "Descrição da rubrica." },
    {
        nome: "Tipo",
        coluna: 4,
        kind: "codigo",
        obrigatorio: true,
        codigos: ["P", "D"],
        descricao: "`P` provento · `D` desconto.",
    },
    {
        nome: "Valor",
        coluna: 5,
        kind: "dinheiro",
        obrigatorio: true,
        descricao: "Valor da rubrica no holerite do mês.",
    },
];
// ---------------------------------------------------------------- saida
export const ABA_MOVIMENTO = "Descontos";
/**
 * A aba do movimento. Uma linha por CONTRATO, com a ADF na coluna
 * `Referencia` — e' o que faz o retorno do mes seguinte casar exato, e o que a
 * declaracao `campos-ausentes: nenhum` promete: nao ha campo do modelo neutro
 * que este layout deixe de escrever.
 */
export const COLUNAS_TESTE_MOVIMENTO = [
    {
        nome: "Matricula",
        coluna: 1,
        kind: "alfa",
        obrigatorio: true,
        descricao: "Matrícula do servidor na folha.",
    },
    { nome: "CPF", coluna: 2, kind: "cpf", obrigatorio: true, descricao: "Onze dígitos, sem máscara." },
    { nome: "Nome", coluna: 3, kind: "alfa", descricao: "Nome do servidor, como a Atlas o conhece." },
    { nome: "Verba", coluna: 4, kind: "alfa", descricao: "Código da verba de desconto." },
    {
        nome: "Descricao",
        coluna: 5,
        kind: "alfa",
        descricao: "Descrição da verba no catálogo de rubricas da unidade, ou o nome do credor.",
    },
    {
        nome: "Valor",
        coluna: 6,
        kind: "dinheiro",
        obrigatorio: true,
        descricao: "Valor da parcela do mês, com **ponto decimal** e sem separador de milhar.",
    },
    { nome: "Parcela", coluna: 7, kind: "num", descricao: "Número da parcela nesta competência." },
    { nome: "Total", coluna: 8, kind: "num", descricao: "Total de parcelas do contrato." },
    {
        nome: "Referencia",
        coluna: 9,
        kind: "alfa",
        obrigatorio: true,
        descricao: "**A ADF** — o identificador da dívida na Atlas. Devolva-a no retorno.",
    },
    {
        nome: "Movimento",
        coluna: 10,
        kind: "codigo",
        codigos: ["I", "A", "E"],
        descricao: "`I` instruir · `A` alteração · `E` parar de descontar.",
    },
    {
        nome: "MesReferencia",
        coluna: 11,
        kind: "dataBr",
        obrigatorio: true,
        descricao: "Primeiro dia da competência, em **AAAA-MM-DD**.",
    },
    {
        nome: "DataCorte",
        coluna: 12,
        kind: "dataBr",
        descricao: "Data de corte da competência, em **AAAA-MM-DD**.",
    },
];
//# sourceMappingURL=planilha-colunas.js.map